/* NOTE: Using Mantine's colors here for compatibility with their components */

/* Mantine 6 doesn't use css variables, so we need to override colors directly */
.tooltipMantine6 {
    @mixin dark {
        background-color: var(--mantine-color-dark-4);
        color: var(--mantine-color-text);
    }
}

/* Keep variables here as we want to mantine handle all other modifications needed */
.tooltip {
    @mixin dark {
        --tooltip-bg: var(--mantine-color-dark-4);
        --tooltip-color: var(--mantine-color-text);
    }
}
